// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5345":"df658e22","6149":"fcd62e24"}[chunkId] + ".chunk.css";
};